/** Small geography helpers (no map library needed, so they can be tested on their own). */

/** Great-circle distance in km */
export function km(a, b) {
  const R = 6371;
  const rad = d => d * Math.PI / 180;
  const dLat = rad(b.lat - a.lat);
  const dLng = rad(b.lng - a.lng);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

/** The n nearest ports to a place, with distances */
export function nearestPorts(place, ports, n) {
  if (n === void 0) {
    n = 3;
  }
  return ports.map(p => ({
    ...p,
    km: Math.round(km(place, p))
  })).sort((a, b) => a.km - b.km).slice(0, n);
}

/** A shipping lane between two ports, bowed offshore (south) so it doesn't cross land */
export function lane(a, b, steps) {
  if (steps === void 0) {
    steps = 16;
  }
  const pts = [];
  const bow = Math.min(0.9, km(a, b) / 400); // degrees offshore at the middle, more for longer legs
  for (let i = 0; i <= steps; i++) {
    const t = i / steps;
    const lng = a.lng + (b.lng - a.lng) * t;
    const lat = a.lat + (b.lat - a.lat) * t - Math.sin(Math.PI * t) * bow;
    pts.push([lng, lat]);
  }
  return pts;
}

/** Does a site match the filters and search words? */
export function matches(site, f, countryName) {
  if (f.category && site.category !== f.category) return false;
  if (f.crop && site.crop !== f.crop) return false;
  if (f.element && site.element !== f.element) return false;
  if (f.country && site.country !== f.country) return false;
  const q = (f.query || '').trim().toLowerCase();
  if (!q) return true;
  const hay = [site.name, site.area, site.resource, site.crop, site.element, countryName(site.country), site.note].join(' ').toLowerCase();
  return q.split(/\s+/).every(w => hay.includes(w));
}